module.exports = __webpack_public_path__ + "static/media/scale.30c20959.svg";